(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('main-register', {
            url: '/main-register',
            templateUrl: 'app/account/main-register/main-register.html',
            controller: 'MainRegisterController',
            controllerAs: 'vm',
            data: {
                authorities: [],
                pageTitle: 'Register to Kaztor',
                specialClass: 'main-register'
            },
            params: {
                'login': null,
                'email': null
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('flyers');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
